import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, Confirm } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext, useSettingsContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'zoho/manageableorder';
const wizardName = 'Apply action';
const wizardAction = 'applyAction';
const wizardObject = 'Zoho Order';


const ApplyAction = (params) => {
    const { t } = useTranslation();
    const { existingModules } = useContext(AppContext);

    // DATA PROVIDER
    const {
        loadAll,
        errorMessage,
        errors,
        saving,
        doAction,
    } = useDataProvider(dataProviderName, params.multipart);

    const moduleConfig = existingModules?.[dataProviderName] ?? {};
    const modelName = moduleConfig?.modelName;
    const availableActions = Array.isArray(moduleConfig?.availableActions)
        ? [...new Set(moduleConfig.availableActions
            .filter(action => typeof action === 'string' && action.trim() !== '')
            .map(action => action.trim()))]
        : [];


    const { settings, editFilter } = useSettingsContext(dataProviderName);


    const filters = {
        sort: settings.sortModel,
        itemsFilters: settings.filterModel,
        perPage: 100000,
        columns: Object.keys(settings.visibilityModel).filter(key => settings.visibilityModel[key] === true),
    }

    const detailConfig = {
        "tabs": [
            {
                "name": "actions",
                "fieldsets": [
                    {
                        "name": "actions",
                        "fields": {
                            "action": {
                                "type": "select",
                                "options": availableActions.map(itm => {
                                    return {
                                        label: itm,
                                        value: itm
                                    }
                                }),
                                "required": true,
                                "className": "col-4"
                            },
                            "apply_to": {
                                "type": "select",
                                "options": [
                                    {
                                        label: "selected_items",
                                        value: "selected_items",
                                    },
                                    {
                                        label: "filtered_items",
                                        value: "filtered_items",
                                    }
                                ],
                                "required": true,
                                "className": "col-8"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [confirmApply, setConfirmApply] = useState(null);

    const handleSave = (data) => {
        setConfirmApply(
            <Confirm
                title={t(wizardName)}
                oklabel={t('Apply')}
                kolabel={t('Cancel')}
                okcallable={async () => {
                    try {
                        const result = await doAction({
                            action: wizardAction,
                            model: dataProviderName,
                            model_ids: params.items,
                            data: { ...data, model_ids: params.items, filters: filters }
                        });
                        setConfirmApply(null);
                        loadAll();
                        if (params.onActionDone) {
                            params.onActionDone();
                        }
                        params.handleClose(params.uid, result.item.data);
                    } catch {
                        console.error('catch handleSave');
                    }
                }}
                kocallable={() => setConfirmApply(null)}
            >
                {t(
                    'Are you sure you want to apply action "{{action}}" to {{applyTo}} ({{total}} items)?',
                    {
                        action: data.action,
                        applyTo: t(data.apply_to),
                        total: params.items.length,
                    }
                )}
            </Confirm>
        );
    };


    return <>
        {confirmApply}
        {/* {params.items.map((item)=>   <>{JSON.stringify(getOne(item))}</>)} */}
        <DetailComponent
            values={{apply_to:"selected_items"}}
            modelName={modelName}
            detailConfig={detailConfig}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={true}
            // canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t(
                        'Apply action to {{wizardObject}} ({{total}} selected)',
                        {
                            wizardObject: t(wizardObject),
                            total: params.items.length,
                        }
                    )}
                />
            }
            {...params}
        />
    </>
}

export default ApplyAction;


